"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupHeader = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.PopupHeader = styled_components_1.default.h2(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 400;\n  font-size: 28px;\n  color: #000000;\n  margin: 0 0 1.5rem 0;\n"], ["\n  font-weight: 400;\n  font-size: 28px;\n  color: #000000;\n  margin: 0 0 1.5rem 0;\n"])));
exports.default = exports.PopupHeader;
var templateObject_1;
